import { IStop } from '@clean-code/types/stops';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '_clean-code/api/client';
import { StopResponse } from '_clean-code/types/Stop';
import { createUrl } from '_clean-code/utils/urlHelper';

export const SHIFT_STOPS_QUERY_KEY = 'shift-stops-table';

export function useShiftStops(shiftId: number) {
  const queryClient = useQueryClient();
  const { data, isFetching, isError, error, refetch, ...rest } = useQuery<
    IStop[]
  >({
    queryKey: [SHIFT_STOPS_QUERY_KEY, shiftId],
    queryFn: async () => {
      const {
        data: { data: stopData }
      } = await api.get<StopResponse>(
        createUrl(`/v2/stops?shiftId=${shiftId}`).toStringUrl()
      );
      return stopData ?? [];
    },
    retry: 2,
    refetchOnMount: 'always',
    // A focus refetch could revert a row edited while it was in flight.
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchInterval: 1000 * 60 * 5 // 5 minutes
  });

  return {
    data,
    isFetching,
    isError,
    error,
    refetch,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [SHIFT_STOPS_QUERY_KEY, shiftId]
      }),
    ...rest
  };
}

export default useShiftStops;
